import { createFileRoute, redirect } from "@tanstack/react-router";

// Public self-serve apply flow has been retired.
// Partner accounts are now created only after our CRM sends the e-sign
// contract and the contact accepts it. Bounce any legacy /partner/apply
// traffic to the partner sign-in page.
export const Route = createFileRoute("/partner/apply")({
  beforeLoad: () => {
    throw redirect({ to: "/partner/login", search: { next: "/partner/onboarding" } as never });
  },
});
